import React, { useState } from "react";
import { Folder } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useTranslation } from 'react-i18next';

import SavedQueryDialog from "components/queries/savedQueries/SavedQueryDialog";
import { Query } from "system/query/Query";

interface LoadSavedQueryButtonProps {
  onChange: (query: Query) => void;
  query?: Query | null;
}

export default function LoadSavedQueryButton(props:LoadSavedQueryButtonProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);

  function handleSavedQueryChange(query: Query) {
    props.onChange(query);
    setOpen(false);
  }

  return (
    <>
      <Button
        endIcon={<Folder />}
        onClick={() => setOpen(true)}
        size="small"
        variant={(props.query) ? "outlined" : "contained"} >
        {i18n.t('query-form.load-saved-query')}
      </Button>
      {open &&
        <SavedQueryDialog
          isOpen={open}
          onClose={() => setOpen(false)}
          onSubmit={(queries: Query[]) => {
            handleSavedQueryChange(queries[0]);
          }}
        />
      }
    </>
  )
}